module.exports = __webpack_public_path__ + "public/Icons/homeSliderNext.png?8f371630";